import React, { Component } from 'react'
import { connect } from "react-redux";

// app config
import AppConfig from 'Constants/AppConfig';
import DatePicker from "react-datepicker";
import moment from 'moment';
import {
	FormGroup,
	Label,	
} from 'reactstrap';

import {
   
   fetchORTChippingReport,
   fetchORTBunkerReport,
   fetchORTWedgeReport,
   fetchORTShortGameReport,
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import ProgressLoader from 'Components/Widgets/ProgressLoader';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';

import BunkerChart from '../../../../golf/onrangetest/onrangereport/component/bunkerchart';
import ChippingChart from '../../../../golf/onrangetest/onrangereport/component/chippingchart';
import ShortGameChart from '../../../../golf/onrangetest/onrangereport/component/shortgamechart';
import WedgeChart from '../../../../golf/onrangetest/onrangereport/component/wedgechart';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';

class RangeLongGame extends Component {
   
   constructor(props) {
      
      super(props);
      
      this.confirmationDialog = React.createRef();
         this.state = {
            student:this.props.data.student, 
            startdate:this.props.data.startdate, 
            enddate:this.props.data.enddate, 
            viewdiv1:true,
            viewdiv2:true,           
            loader:false,   
            frm:2,     
         };  
   } 

   UNSAFE_componentWillMount() {
	   
	} 

  

    selectstart = (date) => {  
        this.setState({ startdate:date });           
    }

    selectend = (date) => {  
        this.setState({ enddate:date });           
    }

    handleSubmit(evt){
        evt.preventDefault();   
        var student=this.state.student;
        var stdate=moment(new Date(this.state.startdate)).format('yyyy-MM-DD');
        var eddate=moment(new Date(this.state.enddate)).format('yyyy-MM-DD');
        var contact='';
        var area='';
        var shot='';
        var distance='';
        this.setState({ 
            loader:true,
            viewdiv2:false,
        });
        this.props.fetchORTShortGameReport(student, stdate, eddate, shot, area, contact);
        this.props.fetchORTChippingReport(student, stdate, eddate, shot, area, contact);
        this.props.fetchORTBunkerReport(student, stdate, eddate, area, contact);
        this.props.fetchORTWedgeReport(student, stdate, eddate, distance, area, contact).then((data) => {   
            var resdata=data.data;            
            this.setState({ 
                loader:false,
                viewdiv2:true,  
            });

        });
        
    }   

   

    render() {
      const { match, loading } = this.props;
      

       return (
          <div className="saas-dashboard">
                <div className="row" style={{marginBottom:"20px"}}>
                        <div className="col-lg-2"><div className="float-left"><button class="mr-3 mb-3 btn btn-info btn-sm float-left" onClick={() => this.props.onClick()}><HomeOutlinedIcon aria-hidden="true" /> Main</button></div></div>
                        <div className="col-lg-8"><h2 className="text-center">ON RANGE SHORT GAME RANDOM</h2></div>
                        <div className="col-lg-2"><div className="float-right"><button class="mr-3 mb-3 btn btn-outline-warning btn-sm float-right" onClick={() => this.props.onClick1()}><KeyboardDoubleArrowLeftIcon aria-hidden="true" /> Back</button></div></div>
                </div>
                <div className="row">
                        
                        {this.state.viewdiv1 &&                             
                            <div className="col-sm-12 col-lg-6" style={{margin:"0 auto"}}>
                                <RctCollapsibleCard>                              
                                    <form autoComplete="off" id="addform" onSubmit={(e)=>this.handleSubmit(e)}>              
                                        <div className="row">                                                    
                                            <div className="col-lg-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="startdate" placeholderText="Start Date"  name="startdate" required autoComplete="off" 
                                                            selected={this.state.startdate}
                                                            onChange={this.selectstart}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown 
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="col-lg-5">
                                                <FormGroup >
                                                    <DatePicker className="form-control" id="enddate" placeholderText="End Date"  name="enddate" required autoComplete="off" 
                                                            selected={this.state.enddate}
                                                            onChange={this.selectend}
                                                            dateFormat='yyyy-MM-dd'
                                                            peekNextMonth
                                                            showMonthDropdown
                                                            showYearDropdown
                                                        /> 
                                                </FormGroup>                                          
                                            </div>
                                            <div className="form-group">                       
                                                <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Filter"/>                                            
                                            </div>              
                                        </div>
                                    </form>  
                                </RctCollapsibleCard>                                                    
                            </div>
                        }
                </div>
               {this.state.viewdiv2 && 
                 <>                
                 <ChippingChart data={this.state}/>
                 <BunkerChart data={this.state}/>
                 <WedgeChart data={this.state}/>
                 <ShortGameChart data={this.state}/>
                 </>
               }

                {this.state.loader &&
                    <div className="col-lg-12">
                        <ProgressLoader />
                    </div>
                }
                
          </div>
       )
    }
 }

const mapStateToProps = ({ mostlyused }) => {
	const { studentlists, loading } = mostlyused;
	return { studentlists, loading };
}

export default connect(mapStateToProps, {
  
   
   fetchORTChippingReport,
   fetchORTBunkerReport,
   fetchORTWedgeReport,
   fetchORTShortGameReport,
})(RangeLongGame); 